var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-textarea',{staticClass:"textarea",attrs:{"hide-details":"","row-height":"38","auto-grow":"","rows":"3","value":_vm.value},on:{"input":newValue => { _vm.$emit('onInput', newValue) }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }